import React from 'react';

export function Benefits(){
  return (
    <div style={{ textAlign: 'left' }}>
      <h1>Benefits</h1>
      <p>
        The benefits of massage therapy and preventative healthcare are paramount, especially in 
        today's world.
      </p>
      <p> 
        The physical benefits of massage therapy include improvents in: 
      </p>
      <ul>
        <li>muscle and joint pain</li>
        <li>tension</li>
        <li>discomfort</li>
        <li>immobility</li>
        <li>water retention</li>
        <li>fatigue</li>
        <li>immobility</li>
        <li>headaches</li>
        <li>athletic restrictions</li>
        <li>allergies</li>
        <li>post-surgical trauma</li>
        <li>recovery time</li>
      </ul>
      <p>The mental health benefits include reliefe from:</p>
      <ul>
        <li>anxiety</li>
        <li>depression</li>
        <li>insomnia</li>
        <li>work-related stress</li>
        <li>addiction</li>
      </ul>
      <p>
        All while promoting relaxation, peace of mind, and detoxification by 
        increasing circulation and improving the body's venous return.
      </p> 
      <p>
        I believe that a better Mind, Body, Community and Life start with each of us. 
        The more positive our attitudes and intentions, the brighter our mind and body. 
        This can help us to better our communities by reducing negativity, depression, 
        discomfort, addiction, crime, etc. 
        Together We CAN Do This!
      </p>
    </div>
  );
}
